import { useEffect, useState } from "react";

import { useAuth } from "@hooks/useAuth";

type FetchUserResponse = {
  isFetched: boolean;
} & ReturnType<typeof useAuth>;

export const useFetchUser = (): FetchUserResponse => {
  const auth = useAuth();
  const [isFetched, setIsFetched] = useState(false);

  useEffect(() => {
    const handleTokenChange = (): void => {
      auth.getUser().then(() => setIsFetched(true));
    };

    window.addEventListener("access_token_change", handleTokenChange);

    auth.getUser().then(() => setIsFetched(true));

    return () => {
      window.removeEventListener("access_token_change", handleTokenChange);
    };
  }, []);

  return {
    isFetched,
    ...auth,
  };
};
